import HttpRouter from "../services/HttpRouter";

export default {
    getUserWithPermissions({},successCallback)
    {
        // Collect user
         HttpRouter.get(null, 'user').then(function (response) {

            var user = response.data.data;

            // If user has a valid ID
            if (typeof user.id !== 'undefined' && user.id > 0) {

                // Collect school
                HttpRouter.get(null, 'user/school').then(function (response) {

                    user.school = response.data.data;

                    // If school has a valid ID
                    if (typeof user.school.id !== 'undefined' && user.school.id > 0) {

                        // this.loading = false;

                        // Collect admin permissions if has any
                        HttpRouter.get(null, 'school/' + user.school.id + '/admins/by_user_id/' + user.id + '?include=permissions').then(function (response) {

                            var admin_user = response.data.data;

                            if (typeof admin_user !== 'undefined' && typeof admin_user.permissions.data !== 'undefined') {

                                user.permissions = admin_user.permissions.data;
                                if(typeof admin_user.teacher_access_to_results  !== 'undefined' && admin_user.teacher_access_to_results == true) {
                                    user.teacher_access_to_results = true;
                                } else {
                                    user.teacher_access_to_results  = false;
                                }
                                // Return data to the Vuex module where it will be stored in the global store
                                successCallback(user);
                            }
                        });
                    } else {
                        addEdNotification('Could not collect users data', "error");
                    }
                });
            } else {
                addEdNotification('Could not collect users data', "error");
            }
        });
    }
}
